import { DateTime } from 'luxon'
import { computed, ref } from 'vue'

import type { PartOfDay } from '@/assets/composables/types'

export const useParkingReservationData = () => {
  const selectedDate = ref<Date[]>([])
  const selectedTime = ref<PartOfDay | null>(null)
  const formattedTime = ref<string>('')
  const step = ref<number>(1)
  const currentDate = ref(DateTime.now())

  const selectedReservationDateIso = computed<string | null>(() => {
    if (!selectedDate.value[0]) return null

    return (
      DateTime.fromJSDate(selectedDate.value[0], { zone: 'system' })
        .setZone('Europe/Bratislava', { keepLocalTime: true })
        .toISODate() || null
    )
  })

  const validation = ref({
    datePicker: false,
    timePicker: false,
  })

  const validateForm = (): boolean => {
    validation.value.datePicker = selectedDate.value.length === 0
    validation.value.timePicker = selectedTime.value === null

    return !Object.values(validation.value).some((value) => value)
  }

  const resetData = (): void => {
    selectedDate.value = []
    selectedTime.value = null
    formattedTime.value = ''
    step.value = 1

    validation.value.datePicker = false
    validation.value.timePicker = false
  }

  return {
    currentDate,
    step,
    selectedDate,
    selectedReservationDateIso,
    selectedTime,
    formattedTime,
    validation,
    validateForm,
    resetData,
  }
}
